import { createClient } from "@sanity/client";

const client = createClient({
  projectId: "i9ym2tp3",
  dataset: "production",
  useCdn: true,
  apiVersion: "2023-04-04",
});

export default client;
